import { ReactNode } from 'react';

import styled from '@emotion/styled';

import COLOR from '../../../../../shared/constant/colorset';
import type { ProductInfoItemTitleType } from '../../../types';

const Wrapper = styled.dl`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: flex-start;
  overflow: hidden;
  width: 100%;
  padding: 17px 0 18px;
  border-top: 1px solid ${COLOR.bg};
  font-size: 14px;
  letter-spacing: -0.5px;
`;

const ProductInfoItemTitle = styled.dt<{ titleLineHeight: number; isBold: boolean }>`
  width: 128px;
  height: 100%;
  color: ${({ isBold }) => (isBold ? COLOR.kurlyGray800 : COLOR.kurlyGray600)};
  font-weight: ${({ isBold }) => (isBold ? 700 : 400)};
  line-height: ${({ titleLineHeight }) => titleLineHeight}px;
`;

const ProductInfoItemValueWrapper = styled.dd`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

interface Props {
  title: ProductInfoItemTitleType | string;
  titleLineHeight?: number;
  isBold?: boolean;
  children: ReactNode;
}

export default function ProductInfoItemWrapper({ title, titleLineHeight = 19, isBold = false, children }: Props) {
  return (
    <Wrapper>
      <ProductInfoItemTitle titleLineHeight={titleLineHeight} isBold={isBold}>
        {title}
      </ProductInfoItemTitle>
      <ProductInfoItemValueWrapper>{children}</ProductInfoItemValueWrapper>
    </Wrapper>
  );
}
